import { createAsyncThunk } from '@reduxjs/toolkit'
import type { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'

import type { ServiceDependenciesOptions } from 'src/services'
import type { ReduxState } from 'src/store/types'

type PayloadCreator<Returned, ThunkArg, ThunkApiConfig> = Parameters<
  typeof createAsyncThunk<Returned, ThunkArg, ThunkApiConfig>
>[1]
type OptionsCreator<Returned, ThunkArg, ThunkApiConfig> = Parameters<
  typeof createAsyncThunk<Returned, ThunkArg, ThunkApiConfig>
>[2]

export const createAppAsyncThunk = <
  Returned,
  ThunkArg = unknown,
  ThunkApiConfig extends { extra: ServiceDependenciesOptions } = { extra: ServiceDependenciesOptions },
>(
  typePrefix: string,
  payloadCreator: PayloadCreator<Returned, ThunkArg, ThunkApiConfig>,
  options?: OptionsCreator<Returned, ThunkArg, ThunkApiConfig>,
) => createAsyncThunk<Returned, ThunkArg, ThunkApiConfig>(typePrefix, payloadCreator, options)

export type TypedDispatch = ThunkDispatch<ReduxState, any, AnyAction>

export const useAppDispatch = useDispatch.withTypes<TypedDispatch>()
export const useAppSelector = useSelector.withTypes<ReduxState>()
